import * as Yup from 'yup';

const MemberFormValidation = Yup.object().shape({
    name: Yup.string()
        .min(3, 'Name must be at least 3 characters')
        .required('Name is required'),

    phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
        .required('Phone number is required'),

    email: Yup.string()
        .email('Invalid email format')
        .required('Email is required'),

    designation: Yup.string()
        .required('Designation is required'),

    joiningDate: Yup.date()
        .required('Joining date is required'),

    maritalStatus: Yup.string()
        .oneOf(['Single', 'Married', 'Divorced', 'Widowed'], 'Invalid marital status')
        .required('Marital status is required'),

    workingField: Yup.string()
        .required('Working field is required'),
    gender: Yup.string()
        .required('Working field is required'),

    salary: Yup.number()
        .typeError('Salary must be a number')
        .min(0, 'Salary cannot be negative')
        .required('Salary is required'),

    reportingTo: Yup.string()
        .required('Reporting to field is required'),

    bloodGroup: Yup.string()
        .oneOf(['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'], 'Invalid blood group')
        .required('Blood group is required'),

    experience: Yup.number()
        .typeError('Experience must be a number')
        .min(0, 'Experience cannot be negative')
        .required('Experience is required'),

    experienceField: Yup.string()
        .required('Experience field is required'),

    address: Yup.string()
        .min(5, 'Address is too short')
        .required('Address is required'),

    aadhaarNumber: Yup.string()
        .matches(/^[0-9]{12}$/, 'Aadhaar number must be exactly 12 digits')
        .required('Aadhaar number is required'),

    photoCopy: Yup.mixed()
        .required('Photo copy is required'),

    signature: Yup.mixed()
        .required('Signature is required'),

    positionColor: Yup.string()
        .required('Position color is required'),
});

export default MemberFormValidation;
